const config = {
  showVersion: "0.2.27a",
  titlePrefix: "Ship Safety",
};
export default config;
